import React, { Component } from 'react';
import './VerifyRegistration.css';

import Page from '@acri-tools/react-tools/components/Page/Page';
import { bannerImage } from '../../theme/images';
import { pushHistory } from '@acri-tools/react-tools/utils/global';
import { match } from 'react-router';
import VR from '@acri-tools/react-tools/components/_user_manager/VerifyRegistration/VerifyRegistration'


interface Props {
    match: match<{ token: string }>,
}


export default class VerifyRegistration extends Component<Props>{
    render() {
        return (
            <Page
                id="verify-registration"
                title="Verify Registration"
                banner={{
                    topBar: true,
                    bannerImage: bannerImage
                }}
                footer
            >
                <div className="page-content">
                    <div className="row-centered-column">
                        <div className="content-div">

                            <VR token={this.props.match?.params?.token} />
                            <div className="centered">
                                <div
                                    className="custom-button login inline"
                                    onClick={() => { pushHistory('/login') }}
                                >
                                    LOGIN
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }

};
